/*
  Description repliable : révèle le bouton « Lire plus » et anime le dépliage.

  Le repli lui-même est fait en CSS dès le premier rendu (classe is-collapsed
  posée côté Liquid), donc aucun flash de la description complète au chargement.

  Le comptage des blocs doit rester identique à celui du CSS : on compte tous
  les enfants de type élément, sans filtrer les paragraphes vides, sinon le JS
  et le sélecteur :nth-child ne seraient plus d'accord.
*/
if (!customElements.get('collapsible-description')) {
  customElements.define(
    'collapsible-description',
    class CollapsibleDescription extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.content = this.querySelector('[data-collapsible-content]');
        this.toggle = this.querySelector('[data-collapsible-toggle]');
        if (!this.content || !this.toggle) return;

        this.visibleBlocks = parseInt(this.dataset.visibleBlocks, 10) || 0;

        // Rien à replier : on retire la troncature et le bouton reste masqué.
        if (this.visibleBlocks < 1 || this.content.children.length <= this.visibleBlocks) {
          this.classList.remove('is-collapsed');
          return;
        }

        this.toggle.hidden = false;
        this.toggle.addEventListener('click', () => this.setExpanded(!this.expanded));
      }

      get expanded() {
        return this.toggle.getAttribute('aria-expanded') === 'true';
      }

      async setExpanded(expanded) {
        const startHeight = this.content.offsetHeight;
        const toggleTop = this.toggle.getBoundingClientRect().top;

        this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        this.classList.toggle('is-collapsed', !expanded);
        this.toggle.querySelectorAll('.label-text').forEach((label) => label.classList.toggle('hidden'));

        const canAnimate = window.FoxTheme && FoxTheme.Motion && !FoxTheme.config.motionReduced;

        if (canAnimate) {
          const endHeight = this.content.offsetHeight;
          this.content.style.overflow = 'hidden';
          // Filet : si la promesse d'animation ne se résout pas, on nettoie quand même
          // les styles inline, sinon le contenu resterait figé à une hauteur fixe.
          await Promise.race([
            FoxTheme.Motion.animate(
              this.content,
              { height: [`${startHeight}px`, `${endHeight}px`] },
              { duration: 0.3, easing: 'ease' }
            ).finished,
            new Promise((resolve) => setTimeout(resolve, 600)),
          ]);
          this.content.style.height = '';
          this.content.style.overflow = '';
        }

        // Au repli, la page remonte sous le curseur : on garde le bouton en place.
        if (!expanded) {
          const delta = this.toggle.getBoundingClientRect().top - toggleTop;
          if (delta < 0 && window.scrollY > 0) window.scrollBy(0, delta);
        }
      }
    }
  );
}
